import { Component, Input } from '@angular/core'
import { FileDownloaderService } from '@shared/components/file-downloader/file-downloader.service'
import {
  ArquivoModel,
  DadosBancariosResidenteModel,
  DadosComplementaresModel,
  DadosPessoaisResidenteModel,
  DadosProfissionaisModel,
  ResidenteModel,
} from '@shared/models/backend'

@Component({
  selector: 'app-residente-dados-pessoais',
  templateUrl: './residente-dados-pessoais.component.html',
})
export class ResidenteDadosPessoaisComponent {
  @Input()
  residente: ResidenteModel

  constructor(private downloaderService: FileDownloaderService) {}

  get dadosPessoais(): DadosPessoaisResidenteModel {
    return this.residente?.dadosResidente?.dadosPessoais
  }

  get dadosProfissionais(): DadosProfissionaisModel {
    return this.residente?.dadosResidente?.dadosProfissionais
  }

  get dadosComplementares(): DadosComplementaresModel {
    return this.residente?.dadosComplementares
  }

  get dadosBancarios(): DadosBancariosResidenteModel {
    return this.residente?.dadosBancarios
  }

  download(arquivo: ArquivoModel): void {
    this.downloaderService.download(arquivo)
  }
}
